// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3P_3p","content":"LayoutSettings_content__1Nvzk"};